import type { LocaleCopy } from "@/lib/i18n/copy";

/**
 * Контент-слой общей обвязки (BTQ-47, шаг A3).
 *
 * Не страница, а то, что рисуется на КАЖДОЙ странице: плавающие кнопки, баннер
 * cookie, хлебные крошки. Пока обвязка не понимает локаль, португальская
 * страница остаётся наполовину английской независимо от того, переведён ли её
 * собственный текст, — поэтому обвязка делается ДО партий, а не попутно.
 *
 * Инвентарь A1 показал, что эти компоненты держат все 43 страницы EB. При этом
 * работы в них мало: шапка и футер стали locale-aware ещё в Гейте 1, а видимого
 * английского на португальской странице оставалась ровно одна кнопка.
 *
 * `Layout.tsx` сюда НЕ входит намеренно: его текст — это JSON-LD канонического
 * узла организации (`#org`, BTQ-33 Phase 1), один на весь сайт. Описание
 * сущности не локализуется вместе со страницей.
 */

export interface StickyCtaCopy {
  /** Подпись кнопки и её же aria-label: они обязаны совпадать. */
  label: string;
}

export interface WhatsAppCopy {
  ariaLabel: string;
  /** Текст, который подставляется в окно WhatsApp за посетителя. */
  prefill: string;
}

export interface BreadcrumbsCopy {
  ariaLabel: string;
  home: string;
}

export interface CookieCopy {
  /** Предложение разрезано ссылкой: lead + linkText + tail. */
  lead: string;
  linkText: string;
  tail: string;
  accept: string;
  decline: string;
}

export const STICKY_CTA: LocaleCopy<StickyCtaCopy> = {
  en: { label: "Begin Planning" },
  pt: { label: "Começar o planeamento" },
};

export const WHATSAPP: LocaleCopy<WhatsAppCopy> = {
  en: {
    ariaLabel: "Chat with Event Boutique on WhatsApp",
    prefill: "Hello! I'd like to plan an event in Portugal.",
  },
  pt: {
    ariaLabel: "Falar com a Event Boutique no WhatsApp",
    prefill: "Olá! Gostaríamos de organizar um evento em Portugal.",
  },
};

export const BREADCRUMBS: LocaleCopy<BreadcrumbsCopy> = {
  en: { ariaLabel: "Breadcrumb", home: "Home" },
  pt: { ariaLabel: "Percurso", home: "Início" },
};

export const COOKIE: LocaleCopy<CookieCopy> = {
  en: {
    lead: "We use cookies and similar technologies (Google Analytics, Yandex.Metrika including Webvisor session recording) to improve your experience and analyse site traffic. Read our",
    linkText: "Privacy Policy",
    tail: "for more details.",
    accept: "Accept",
    decline: "Decline",
  },
  pt: {
    lead: "Utilizamos cookies e tecnologias semelhantes (Google Analytics e Yandex.Metrika, incluindo a gravação de sessões com o Webvisor) para melhorar a experiência de navegação e analisar o tráfego do site. Consulte a",
    linkText: "Política de Privacidade",
    tail: "para mais detalhes.",
    accept: "Aceitar",
    decline: "Recusar",
  },
};
